import styled from 'styled-components';
import media from 'styled-media-query';

export const AccountSettingsHeader = styled.h2`
  margin: 0 0 2rem;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1em;

  ${media.lessThan('medium')`
    margin-bottom: 2rem;
  `}
`;
